import { render } from "./JobDetailView.vue?vue&type=template&id=487e5acd&scoped=true"
import script from "./JobDetailView.vue?vue&type=script&lang=js"
export * from "./JobDetailView.vue?vue&type=script&lang=js"

import "./JobDetailView.vue?vue&type=style&index=0&id=487e5acd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487e5acd"]])

export default __exports__